var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.695923 7.61103C0.695923 7.1324 0.695923 6.89309 0.757612 6.6727C0.812257 6.47748 0.902061 6.29386 1.02261 6.13087C1.1587 5.94687 1.34761 5.79994 1.72541 5.50609L7.37734 1.11016C7.67011 0.882445 7.81649 0.76859 7.97813 0.724824C8.12076 0.686208 8.27109 0.686208 8.41371 0.724824C8.57535 0.76859 8.72174 0.882445 9.01451 1.11016L14.6664 5.5061C15.0442 5.79995 15.2331 5.94687 15.3692 6.13087C15.4898 6.29386 15.5796 6.47748 15.6342 6.6727C15.6959 6.89309 15.6959 7.1324 15.6959 7.61103V13.6401C15.6959 14.5736 15.6959 15.0403 15.5143 15.3968C15.3545 15.7104 15.0995 15.9654 14.7859 16.1252C14.4294 16.3068 13.9627 16.3068 13.0293 16.3068H3.36259C2.42917 16.3068 1.96246 16.3068 1.60594 16.1252C1.29234 15.9654 1.03737 15.7104 0.877579 15.3968C0.695923 15.0403 0.695923 14.5736 0.695923 13.6401V7.61103Z",
    stroke: "#717680",
    strokeWidth: 1.39167,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/home-icon.1850a35e6176735f175b101debd678bb.svg";
export { ForwardRef as ReactComponent };